import _ from "lodash";
import React, { PureComponent } from "react";
import { Table } from "semantic-ui-react";
import "./AssignmentListTable.css";
import moment from "moment";
import StatusPill from "../StatusPill/StatusPill";
import TableFilter from "../TableFilter/TableFilter";

export default class AssignmentListTable extends PureComponent {
  state = {
    column: null,
    data: this.props.tableData,
    direction: null,
    filters: {
      status: null,
      client: null,
    },
  };

  componentDidUpdate(prevProps) {
    if (
      prevProps.originalArticles !== this.props.originalArticles ||
      prevProps.originalTemplates !== this.props.originalTemplates
    ) {
      this.setState({
        data: _.sortBy(this.props.originalArticles, [this.state.column]),
      });
    }
  }

  handleSort = (clickedColumn, isDate) => () => {
    const { column, data, direction } = this.state;

    if (column !== clickedColumn) {
      this.setState({
        column: clickedColumn,
        data: isDate
          ? data.sort(
              (a, b) =>
                moment([
                  a.planning_year_month.year,
                  a.planning_year_month.month,
                  1,
                ]) -
                  moment([
                    b.planning_year_month.year,
                    b.planning_year_month.month,
                    1,
                  ]) || a.project.name - b.project.name
            )
          : _.sortBy(data, [clickedColumn]),
        direction: "ascending",
      });

      return;
    }

    this.setState({
      data: data.reverse(),
      direction: direction === "ascending" ? "descending" : "ascending",
    });
  };

  handleFilter = (event, { name, value }) => {
    this.setState({
      filters: {
        ...this.state.filters,
        [name]: value !== "" ? value : null,
      },
    });
  };

  handleTableFilter = (data) => {
    if (this.state.filters) {
      return data.filter(
        (d) =>
          (this.state.filters.status
            ? d.status.id === this.state.filters.status
            : d) &&
          (this.state.filters.client
            ? d.client.id === this.state.filters.client
            : d)
      );
    } else {
      return data;
    }
  };

  ifData = (data) => {
    if (this.props.tableData[0]) {
      if (data in this.props.tableData[0]) {
        return true;
      } else {
        return false;
      }
    }
  };

  isSelected = (id) => {
    if (this.props.selectedItem) {
      if (this.props.selectedItem.id === id) {
        return true;
      } else {
        return false;
      }
    }
  };

  render() {
    const { column, data, direction } = this.state;

    return (
      <div className={`AssignmentListTable`}>
        {!this.props.customerView && (
          <div className="AssignmentListTableFilters">
            <TableFilter
              options={
                this.props.contentStatuses &&
                this.props.contentStatuses
                  .filter((status) => status.status_type === 'Active')
                  .map((status) => ({
                    key: status.id,
                    text: status.name,
                    value: status.id,
                  }))
              }
              filterName="status"
              placeholder="Filter Status"
              handleChange={this.handleFilter}
            />
            <TableFilter
              options={
                this.props.organizations &&
                this.props.organizations.map((org) => ({
                  key: org.id,
                  text: org.dba_name,
                  value: org.id,
                }))
              }
              filterName="client"
              placeholder="Filter Account"
              handleChange={this.handleFilter}
            />
          </div>
        )}
        <div className="AssignmentListTable--Table">
          <Table size="small" compact sortable celled selectable>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell
                  sorted={column === "title" ? direction : null}
                  onClick={this.handleSort("title")}
                >
                  Title
                </Table.HeaderCell>
                <Table.HeaderCell
                  sorted={
                    column === "planning_year_month.id" ? direction : null
                  }
                  onClick={this.handleSort("planning_year_month.id")}
                  textAlign="center"
                >
                  Month{!this.props.customerView && " / Project"}
                </Table.HeaderCell>
                <Table.HeaderCell
                  sorted={column === "content_type.name" ? direction : null}
                  onClick={this.handleSort("content_type.name")}
                  textAlign="center"
                >
                  Type
                </Table.HeaderCell>
                {this.ifData("status") && (
                  <Table.HeaderCell
                    sorted={column === "status.name" ? direction : null}
                    onClick={this.handleSort("status.name")}
                    textAlign="center"
                  >
                    Status
                  </Table.HeaderCell>
                )}
                {!this.props.customerView && (
                  <Table.HeaderCell
                    sorted={column === "status.name" ? direction : null}
                    onClick={this.handleSort("status.name")}
                    textAlign="center"
                  >
                    Organization
                  </Table.HeaderCell>
                )}
                {this.props.renderDueDate && (
                  <Table.HeaderCell
                    sorted={column === "correspondingDueDate" ? direction : null}
                    onClick={this.handleSort("correspondingDueDate")}
                    textAlign="center"
                  >
                    Due Date
                  </Table.HeaderCell>
                )}
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {data &&
                data[0] &&
                this.handleTableFilter(data).map(
                  (d, i) =>
                    !d.archived && (
                      <Table.Row
                        className={`AssignmentListTableRow ${
                          this.isSelected(d.id) ? "selected" : "notSelected"
                        }`}
                        onClick={(e) => this.props.handleSelect(d)}
                        key={d.id}
                      >
                        <Table.Cell>{d.title}</Table.Cell>
                        <Table.Cell textAlign="center">
                          <span>
                            {d.planning_year_month &&
                            d.planning_year_month.month ? (
                              <span>
                                <span>
                                  {moment(
                                    d.planning_year_month.month,
                                    "MM"
                                  ).format("MMM")}
                                </span>{" "}
                                <span>{d.planning_year_month.year}</span>
                              </span>
                            ) : this.props.customerView ? (
                              <span>None</span>
                            ) : d.project ? (
                              <span>{d.project.name}</span>
                            ) : (
                              <span>None</span>
                            )}
                          </span>
                        </Table.Cell>
                        <Table.Cell textAlign="center">
                          {d.content_type.name}
                        </Table.Cell>
                        {this.ifData("status") && (
                          <Table.Cell textAlign="center">
                            <StatusPill
                              color={d.status.color}
                              content={d.status.name}
                            />
                          </Table.Cell>
                        )}
                        {!this.props.customerView && d.client && (
                          <Table.Cell textAlign="center">
                            <span>{d.client.dba_name}</span>
                          </Table.Cell>
                        )}
                        {this.props.renderDueDate && (
                          <Table.Cell textAlign="center">
                            <span
                              className={`AssignmentListTable--duedate ${
                                this.props.renderDueDate(d, true) > moment()
                                  ? "onTime"
                                  : "late"
                              }`}
                            >
                              {this.props.renderDueDate(d) ? (
                                this.props.renderDueDate(d)
                              ) : (
                                <span className="noFormat">-</span>
                              )}
                            </span>
                          </Table.Cell>
                        )}
                      </Table.Row>
                    )
                )}
            </Table.Body>
          </Table>
        </div>
      </div>
    );
  }
}
